<template>
  <app-drawer
    drawer-ref="transfer-recipient-drawer"
    heading="Beneficiary details"
    :is-open="transferRecipientDrawerStore.isOpen"
    :click-outside-allow-classes="['transfer-recipient-table']"
    :is-loading="isRecipientPending"
    @close="close"
  >
    <template #body>
      <div class="flex flex-col gap-8">
        <transfer-recipient-card
          :agency-id="agencyId"
          :transfer-recipient-id="recipientId"
          :is-loading="isRecipientPending"
          @edit:transfer-recipient="handleTransferRecipient"
        />
        <transfer-recipient-invoice-provider-alert
          v-if="!isRecipientPending && transferRecipient?.invoice_provider !== InvoiceProviders.SION"
          :invoice-provider="transferRecipient.invoice_provider"
          message-override="PDFs will not be generated for transfers."
          is-agency
        />
        <transfer-recipient-drawer-details
          :is-loading="isRecipientPending"
          :transfer-recipient="transferRecipient"
        />
        <transfer-recipient-drawer-identifier-list
          v-if="!isRecipientPending"
          :agency-id="agencyId"
          :transfer-recipient-id="transferRecipient.id"
        />
      </div>
    </template>
  </app-drawer>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useTransferRecipientById } from '@/services/transfer-recipients/queries.js';
import { useTransferRecipientDrawerStore } from '@/stores/transferRecipients.js';
import { InvoiceProviders } from '@/constants/transfer-recipients';
import TransferRecipientCard from '@/components/transfer-recipients/TransferRecipientCard.vue';
import TransferRecipientDrawerDetails from '@/components/transfer-recipients/TransferRecipientDrawerDetails.vue';
import TransferRecipientDrawerIdentifierList from '@/components/transfer-recipients/TransferRecipientDrawerIdentifierList.vue';
import TransferRecipientInvoiceProviderAlert from '@/components/transfer-recipients/TransferRecipientInvoiceProviderAlert.vue';

const router = useRouter();
const route = useRoute();

const emit = defineEmits(['close']);

const transferRecipientDrawerStore = useTransferRecipientDrawerStore();
const recipientId = computed(() => transferRecipientDrawerStore.recipientId);

const { data: recipientData, isPending: isRecipientPending } = useTransferRecipientById(recipientId);

const agencyId = computed(() => route.params.agencyId || transferRecipient.value?.agency?.id);
const transferRecipient = computed(() => recipientData?.value?.data || {});

const agencyLiteRoutes = ['agency-lite-transfer-recipient', 'agency-lite-transfer-recipients'];
const agencyDetailsRoutes = ['agency-details-transfer-recipient', 'agency-details-transfer-recipients'];

function handleTransferRecipient(transferRecipientId) {
  if (agencyLiteRoutes.includes(route.name)) {
    router.push({
      name: 'agency-lite-transfer-recipient-edit',
      params: { recipientId: transferRecipientId },
    });
  }

  if (agencyDetailsRoutes.includes(route.name)) {
    router.push({
      name: 'agency-details-transfer-recipient-edit',
      params: {
        recipientId: transferRecipientId,
        agencyId: agencyId.value,
      },
    });
  }
}

const close = () => {
  if (agencyLiteRoutes.includes(route.name)) {
    router.replace({ name: 'agency-lite-transfer-recipients' });
  }
  if (agencyDetailsRoutes.includes(route.name)) {
    router.replace({
      name: 'agency-details-transfer-recipients',
      params: { agencyId: agencyId.value },
    });
  }
  transferRecipientDrawerStore.closeDrawer();
  emit('close');
};
</script>
